// Third-party Imports
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";

// Type Imports
import type { UserActivityType } from "@/types/apps/userActivityTypes";

// Server Imports
import { doGetuserActivityTimelineFullTable } from "@/app/server/actions";

const initialState: UserActivityType = {
  activities: [],
  filteredActivities: [],
  loading: "idle" as string | "pending" as string | "succeeded" as string | "failed" as string,
  error: null,
  total: 0,
};

export const fetch = createAsyncThunk<any, any, any>(
  "user_activity/fetch",
  async (_: void) => {
    const response = await doGetuserActivityTimelineFullTable() as any;

    // Ensure response is an array — null means no logs yet (index doesn't exist), not an error
    const activities = Array.isArray(response) ? response : [];

    return {
      data: activities,
      total: activities.length,
    };
  },
);

export const userActivitySlice = createSlice({
  name: "userActivity",
  initialState: initialState,
  reducers: {
    filterTable: (state, action) => {
      const { start, end, status } = action.payload;
      const stateData = JSON.parse(JSON.stringify(state));

      if (status === "default") {
        const startDateInput: Date = new Date(start);

        startDateInput.setHours(0, 0, 0, 0);

        const endDateInput: Date = new Date(end);

        endDateInput.setHours(23, 59, 59, 59);

        const setSearchDate: any = (date: Date) => {
          const searchDateInput = new Date(date);

          return searchDateInput.setHours(23, 59, 59, 59);
        };

        const filteredData: any = stateData.activities.filter(
          (response: any) => setSearchDate(response.createdAt) >= startDateInput && setSearchDate(response.createdAt) <= endDateInput
        );

        state.filteredActivities = filteredData;
      } else {
        const filteredData: any = stateData.activities.filter((response: any) => response.status === (status || response.status));

        const startDateInput: Date = new Date(start);

        startDateInput.setHours(0, 0, 0, 0);

        const endDateInput: Date = new Date(end);

        endDateInput.setHours(23, 59, 59, 59);

        const setSearchDate: any = (date: Date) => {
          const searchDateInput = new Date(date);

          return searchDateInput.setHours(23, 59, 59, 59);
        };

        const filteredData2: any = filteredData.filter(
          (response: any) => setSearchDate(response.createdAt) >= startDateInput && setSearchDate(response.createdAt) <= endDateInput
        );

        state.filteredActivities = filteredData2;
      }
    },
  },
  extraReducers: builder => {
    // Add reducers for additional action types here, and handle loading state as needed
    builder.addCase(fetch.pending, state => {
      state.loading = "idle";
    });
    builder.addCase(fetch.rejected, (state, action) => {
      // Don't show error if the request was aborted
      if (action.meta.aborted) {
        state.loading = "idle";
        return;
      }

      state.loading = "failed";
      state.error = action.payload;

      // Only show toast if there's an actual error
      if (action.payload) {
        toast.error("Failed to load activity. Please try again.", {
          toastId: "activity-load-error",
        });
      }
    });
    builder.addCase(fetch.fulfilled, (state, action) => {
      state.activities = action.payload.data;
      state.filteredActivities = action.payload.data;
      state.total = action.payload.total;
      state.loading = "succeeded";
    });
  },
});

export const { filterTable } = userActivitySlice.actions;

export default userActivitySlice.reducer;
